import styled from 'styled-components'
import { Link } from 'react-router-dom'
import media from '../../../../services/generateMediaQueries'

export const AlternateLoginPrompt = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  align-items: center;
  color: #3b3636;
`
export const Divider = styled.div`
  width: 40%;
  border-bottom: #868686 1px solid;
`
export const FormWrapper = styled.div`
  width: 350px;
  ${media.lessThan('medium')`
    width: 100%;
  `}
`
export const SocialButtonWrapper = styled.div`
  width: 350px;
  ${media.lessThan('medium')`
    width: 100%;
  `}
`
export const SocialButton = styled.button`
  display: inline-flex;
  align-items: center;
  outline: 0;

  font-size: 1rem;
  padding: 10px 20px;
  font-weight: var(--font-weight-bold);
  border-radius: var(--border-radius-button);
  cursor: pointer;
  margin-bottom: 10px;
  color: ${props => props.color};
  border: ${props => props.color} 1px solid;
  width: 100%;
  background: transparent;

  > svg {
    font-size: 32px;
  }
`
export const SocialButtonLabel = styled.span`
  text-align: center;
  width: calc(100% - 32px);
`
export const ContentContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 80px;
  padding-bottom: 20px;
  justify-content: space-between;
  align-items: center;
  ${media.lessThan('medium')`
    padding: 40px;
    padding-bottom: 0;
    min-height: ${props => props.minHeight || '550'}px;
  `}

  ${media.lessThan('small')`
    padding: 0 40px;
  `}
`
export const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  max-width: 350px;
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  color: #3b3636;
  font-weight: var(--font-weight-boldest);
  ${media.lessThan('small')`
    max-width: 100%;
    margin-top: revert;
  `}
`
export const Description = styled.p`
  text-align: center;
  max-width: 300px;
  margin: auto;
`
export const StyledLink = styled(Link)`
  text-decoration: none;
  font-weight: var(--font-weight-boldest);
  color: var(--color-secondary) !important;
`
export const LinkDescription = styled.div`
  margin: 1em 0;
  text-align: center;
`
